// authErrorHandler.js
let onAuthErrorCallback = null;

export function setAuthErrorHandler(callback) {
  onAuthErrorCallback = callback;
}

export function triggerAuthError() {
  if (typeof onAuthErrorCallback === "function") {
    onAuthErrorCallback();
  }
}